import { Component, OnInit, ElementRef, ViewChild, EventEmitter, Output, HostListener } from '@angular/core';
import { DataService } from '../data.service';
import { ShortcutService } from '../shortcut.service';

@Component({
  selector: 'app-pen-window',
  templateUrl: './pen-window.component.html',
  styleUrls: ['./pen-window.component.scss']
})
export class PenWindowComponent implements OnInit {

  /** @var {ElementRef} slider['nativeElement'] grants referenece to the HTMLElement of this component's container */
  @ViewChild("container", {static: false, read: ElementRef }) container: ElementRef;
  /** @var {ElementRef} slider['nativeElement'] grants referenece to the HTMLElement of this component's container */
  @ViewChild("slider", {static: false, read: ElementRef }) slider: ElementRef;
  @Output() colorEmitter = new EventEmitter<string>();
  @Output() sizeEmitter = new EventEmitter<number>();
  @Output() visibilityEmitter = new EventEmitter<boolean>();
  @Output() clearEmitter = new EventEmitter<boolean>();
  @Output() exitEmitter = new EventEmitter<boolean>();
  public active: boolean;
  public hide: boolean;
  public color: string;
  public size: number;
  public visibility: boolean;

  constructor(
    private dataService: DataService,
    private shortcutService: ShortcutService
  ) { }

  ngOnInit() { }

  ngAfterViewInit() {
    this.slider['nativeElement'].getElementsByClassName("mat-slider-thumb")[0].style.cursor = "pointer";
    this.setColor("#000");
    this.setVisibility();
    this.dataService.penWindow = this;
  }

  setColor(color: string) {
    this.color = color;
    this.colorEmitter.emit(color);
    this.slider['nativeElement'].getElementsByClassName("mat-slider-thumb")[0].style.borderColor = color;
    this.slider['nativeElement'].getElementsByClassName("mat-slider-thumb")[0].style.backgroundColor = color;
    this.slider['nativeElement'].getElementsByClassName("mat-slider-track-fill")[0].style.backgroundColor = color;
    if (color === "n") {
      this.slider['nativeElement'].getElementsByClassName("mat-slider-thumb")[0].style.borderColor = "#000a19";
      this.slider['nativeElement'].getElementsByClassName("mat-slider-thumb")[0].style.backgroundColor = "#001f4d";
      this.slider['nativeElement'].getElementsByClassName("mat-slider-track-fill")[0].style.backgroundColor = "#000a19";
    }
  }

  setSize($event) {
    this.size = $event;
    this.sizeEmitter.emit(this.size);
  }
  
  setVisibility() {
    if (this.visibility)
      this.visibility = false;
    else
      this.visibility = true;
    this.visibilityEmitter.emit(this.visibility);
  }

  clear() {
    this.clearEmitter.emit(true);
  }

  enter() {
    this.active = true;
    this.exitEmitter.emit(false);
    this.container['nativeElement'].style.display="block";
    document.getElementById("penButton").classList.add("highlight");
  }

  exit() {
    this.active = false;
    this.exitEmitter.emit(true);
    this.container['nativeElement'].style.display="none";
    document.getElementById("penButton").classList.remove("highlight");
  }

  setHide() {
    if (this.hide)
      this.hide = false;
    else
      this.hide = true;
  }

  // Depreciated
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (this.shortcutService.enabled) {
      if (event.keyCode === 80) {
        if (this.active) {
          //this.exit();
        } else {
          //this.enter();
        }
      }
    }
  }
}
